import React from "react";
import { useFieldStackSpacing } from "./fieldStackContext";

const RadioGroup = ({
  name,
  mainLabel,
  secondaryLabel,
  children,
  register,
  required = true,
  onYes,
  onNo,
  yesValue = "Yes",
  noValue = "No",
  labelYes = "Yes",
  labelNo = "No",
  errors,
  trigger,
}) => {
  const isInFieldStack = useFieldStackSpacing();
  const hasSupplementaryContent = Boolean(secondaryLabel || children);

  const handleSelection = (callback) => (event) => {
    callback?.(event);
    trigger?.(name);
  };

  return (
    <div className={`tw-w-full ${isInFieldStack ? "" : "tw-mb-[15px]"}`}>
      <fieldset className="tw-m-0 tw-min-w-0 tw-border-0 tw-p-0">
        {mainLabel && (
          <legend
            className={`tw-mt-0 tw-block tw-text-base tw-font-bold tw-text-dis-navy ${
              hasSupplementaryContent ? "tw-mb-1" : "tw-mb-3"
            }`}
          >
            {mainLabel}
          </legend>
        )}

        {secondaryLabel && (
          <div className="tw-mb-3 tw-text-dis-text-muted">{secondaryLabel}</div>
        )}

        {children && <div className="tw-mb-2">{children}</div>}

        <div className="tw-flex tw-flex-row tw-flex-wrap tw-gap-x-8 tw-gap-y-2">
          <label className="tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-text-base tw-text-dis-text-2">
            <span>{labelYes}</span>
            <input
              className="tw-m-0 tw-h-5 tw-w-5 tw-cursor-pointer tw-accent-dis-deep-blue"
              type="radio"
              value={yesValue}
              {...register(name, { required })}
              onClick={handleSelection(onYes)}
            />
          </label>
          <label className="tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-text-base tw-text-dis-text-2">
            <span>{labelNo}</span>
            <input
              className="tw-m-0 tw-h-5 tw-w-5 tw-cursor-pointer tw-accent-dis-deep-blue"
              type="radio"
              value={noValue}
              {...register(name, { required })}
              onClick={handleSelection(onNo)}
            />
          </label>
        </div>
      </fieldset>

      {errors && (
        <span
          className={`tw-mt-[5px] tw-block tw-text-sm tw-text-dis-error ${
            isInFieldStack ? "" : "tw-mb-[5px]"
          }`}
        >
          {errors.message || "Required"}
        </span>
      )}
    </div>
  );
};

export default RadioGroup;
